/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecipeResponseDto } from '../../models/recipe-response-dto';

export interface RecipeControllerGetRecipe$Params {
  id: string;
}

export function recipeControllerGetRecipe(http: HttpClient, rootUrl: string, params: RecipeControllerGetRecipe$Params, context?: HttpContext): Observable<StrictHttpResponse<RecipeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, recipeControllerGetRecipe.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecipeResponseDto>;
    })
  );
}

recipeControllerGetRecipe.PATH = '/products/{id}/recipe';
